import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useClubs } from '../context/AppContext';
import FeedPage from './FeedPage';

const InsiderFeedPage: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const navigate = useNavigate();
  const { clubs } = useClubs();

  const club = clubs.find(c => c.id === clubId);

  if (!club) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="error">Club not found</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh' }}>
      {/* Custom Header for Insider Feed */}
      <Box sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        backgroundColor: 'white',
        borderBottom: '1px solid #e4e6ea',
        px: { xs: 2, sm: 3 },
        py: { xs: 1.5, sm: 2 },
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}>
        <IconButton
          onClick={() => navigate(`/clubs/${clubId}`)}
          sx={{
            backgroundColor: '#f0f2f5',
            '&:hover': {
              backgroundColor: '#e4e6ea'
            }
          }}
        >
          <ArrowBackIcon />
        </IconButton>

        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#1877f2',
              fontSize: { xs: '1.2rem', sm: '1.4rem' },
              lineHeight: 1.2
            }}
          >
            {club.name}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.85rem' },
              fontWeight: 500
            }}
          >
            Insider Feed
          </Typography>
        </Box>
      </Box>

      {/* Feed Content */}
      <Box sx={{ pt: 0 }}>
        <FeedPage
          clubId={clubId}
          clubName={club.name}
          isInsiderFeed={true}
        />
      </Box>
    </Box>
  );
};

export default InsiderFeedPage;